'use client';

import React, { Suspense, lazy } from 'react';

import { Spinner } from '@chakra-ui/spinner';
import type { ChatActions } from './Context';

const ClientOnlyChatProvider = lazy(async () => import('./ClientOnlyChatProvider'));

// This component provides the trpc client for the support chat service.
export function ChatProvider({
  chatActions,
  children,
}: {
  chatActions: ChatActions;
  children?: React.ReactNode;
}) {
  return (
    <Suspense fallback={<Spinner />}>
      <ClientOnlyChatProvider chatActions={chatActions}>{children}</ClientOnlyChatProvider>
    </Suspense>
  );
}

export default ChatProvider;
